// CONF
import { ListConf } from './conf/List.conf';
import { FilterConf } from './conf/Filter.conf';
import { SearchConf } from './conf/Search.conf';
import { DetailConf } from './conf/Detail.conf';
import { CreateConf } from './conf/Create.conf';

// REDUX
import { reducer, actions, detailSelector, filterSelector } from './slice';

// SELECTOR
import { tag, querySelector, listSelector } from './slice';

// SAGA
import { saga } from './saga';

// API
import { API } from './api';
import { ActionConf } from './conf/Action.conf';

export { reducer, saga, tag };

const handover = {
  tag,
  query: {
    all: {
      selector: querySelector,
      action: actions.fetchAllAction,
      settings: API.tickets,
      populate: '*',
    },
    detail: {
      action: actions.fetchDetailAction,
      settings: API.getTicket,
      populate: '*',
    },
    delete: {
      settings: API.deleteTicket,
    },
    sendMail: {
      settings: API.sendMail,
    },
    action: {
      settings: API.updateAll,
    },
  },
  search: {
    conf: SearchConf,
    actions: {
      search: actions.searchChange,
    },
  },
  filter: {
    conf: FilterConf,
    selector: filterSelector,
    actions: {
      filter: actions.filterChange,
    },
  },
  list: {
    conf: ListConf,
    actions: {
      pagination: actions.paginationChange,
      sort: actions.sortChange,
      selected: actions.selectedRowChange,
      selectedAll: actions.selectedAllChange,
      resetSelect: actions.resetSelectedAllChange,
    },
    selector: {
      data: listSelector,
    },
    add: {
      to: 'add',
    },
  },
  detail: {
    conf: DetailConf,
    selector: {
      data: detailSelector,
    },
    edit: {
      to: 'edit',
    },
    viewID: true,
  },
  create: {
    conf: CreateConf,
  },
  remove: {
    selector: {
      data: detailSelector,
    },
    navigate: '/handover',
  },
  action: {
    conf: ActionConf,
  },
};

export default handover;
